import React from "react";
import { ListTableColumn, ShimmeredDetailsList, Stack, Text } from "sprint-common-web";

import { ConformingAssetListingItem } from "./ConformingAssetItem";

interface ConformingAssetListProps {
    items: ConformingAssetListingItem[];
    columns: ListTableColumn<ConformingAssetListingItem>[];
    isLoading: boolean;
}

export const ConformingAssetList: React.FC<ConformingAssetListProps> = (props: ConformingAssetListProps) => {
    const { items, columns, isLoading } = props;

    return (
        <Stack>
            {items.length || isLoading ? (
                <ShimmeredDetailsList
                    columns={columns}
                    items={items}
                    layoutMode="justified"
                    enableShimmer={isLoading}
                    shimmerLines={3}
                />
            ) : (
                <Text>No conforming assets</Text>
            )}
        </Stack>
    );
};
